import { useContext } from "react";
import { CartContext } from "../context/CartContext";
import { Link } from "react-router-dom";

export default function Cart() {
  const { cart, addToCart, removeFromCart, total } = useContext(CartContext);

  return (
    <main className="max-w-[1280px] mx-auto px-6 py-8">
      <h1 className="text-3xl font-extrabold mb-6">Your Cart</h1>

      <div className="grid grid-cols-1 lg:grid-cols-12 gap-8">
        <div className="lg:col-span-8 space-y-6">
          {cart.length === 0 ? (
            <div className="p-6 bg-white dark:bg-[#2d2a1b] rounded-2xl border border-[#e7e3cf] dark:border-[#3d3a2a] shadow-sm text-center">
              <p className="text-lg">Your cart is empty.</p>
              <Link to="/" className="mt-4 inline-block text-primary font-bold hover:underline">Continue shopping</Link>
            </div>
          ) : (
            cart.map((item) => (
              <div key={item.id} className="p-6 bg-white dark:bg-[#2d2a1b] rounded-2xl border border-[#e7e3cf] dark:border-[#3d3a2a] shadow-sm grid grid-cols-1 md:grid-cols-12 gap-4 items-center">
                <div className="md:col-span-3">
                  <div className="aspect-[4/5] rounded-xl overflow-hidden bg-[#f3f1e7]">
                    <img src={(item.imgVariants && item.imgVariants[0]) || "/logo192.png"} alt={item.name} className="w-full h-full object-cover" />
                  </div>
                </div>
                <div className="md:col-span-6">
                  <h3 className="font-bold text-lg">{item.name}</h3>
                  {item.selectedLength && <p className="text-sm text-[#9a8d4c]">Length: {item.selectedLength}</p>}
                  {item.selectedColor && <p className="text-sm text-[#9a8d4c]">Color: {item.selectedColor}</p>}
                  <p className="text-sm mt-2">{item.description || ''}</p>
                </div>
                <div className="md:col-span-3 flex flex-col items-end gap-3">
                  <div className="flex items-center gap-2">
                    <button
                      type="button"
                      className="px-3 py-2 bg-[#f3f1e7] rounded-lg"
                      onClick={() => addToCart(item)}
                      aria-label="Increase quantity"
                    >
                      +
                    </button>
                    <div className="px-3 py-2 font-bold">{item.qty}</div>
                    <button
                      type="button"
                      className="px-3 py-2 bg-[#fff1f0] rounded-lg text-red-600"
                      onClick={() => removeFromCart(item.id)}
                      aria-label="Remove item"
                    >
                      Remove
                    </button>
                  </div>
                  <div className="text-right">
                    <div className="text-sm text-[#9a8d4c]">Unit: ${Number(item.starting_price).toFixed(2)}</div>
                    <div className="text-xl font-black">${(Number(item.starting_price) * item.qty).toFixed(2)}</div>
                  </div>
                </div>
              </div>
            ))
          )}
        </div>

        <aside className="lg:col-span-4">
          <div className="p-6 bg-white dark:bg-[#2d2a1b] rounded-2xl border border-[#e7e3cf] dark:border-[#3d3a2a] shadow-sm space-y-4">
            <h2 className="text-xl font-bold">Order Summary</h2>
            <div className="flex justify-between text-sm text-[#9a8d4c]"><span>Subtotal</span><span>${total.toFixed(2)}</span></div>
            <div className="flex justify-between text-sm text-[#9a8d4c]"><span>Shipping</span><span>Calculated at checkout</span></div>
            <div className="border-t pt-4">
              <div className="flex justify-between items-center">
                <div>
                  <div className="text-sm text-[#9a8d4c]">Total</div>
                  <div className="text-2xl font-extrabold">${total.toFixed(2)}</div>
                </div>
              </div>
              <Link to="/checkout" className="block mt-4 w-full text-center bg-primary text-background-dark py-3 rounded-xl font-black hover:brightness-105">Proceed to Checkout</Link>
              <Link to="/" className="block mt-2 text-center text-sm text-primary font-bold hover:underline">Continue shopping</Link>
            </div>
          </div>
        </aside>
      </div>
    </main>
  );
}